import React, { useEffect } from "react";
import { AdvertCard } from "../AdvertCard";
import { useSelector } from "react-redux";
import { AdvertPreviewLayout } from "./AdvertPreviewLayout";

export const AllAdverts = () => {
  const adverts = useSelector((state) => state.misc.adverts) || [];
  usePrintDimensions();

  return (
    <AdvertPreviewLayout>
      {adverts.map((advert, index) => (
        <article key={index} className="mt-3">
          <AdvertCard {...advert} />
        </article>
      ))}
    </AdvertPreviewLayout>
  );
};

const usePrintDimensions = () => {
  useEffect(() => {
    window.addEventListener("resize", () => {
      let elements = Array.from(document.getElementsByClassName("advertcard"));
      let heights = elements.map((element) => element.offsetHeight);
      console.info("Banner heights: " + heights);
    });
  });
};
